import { apiInterceptor } from 'utils/apiInterceptor';
export async function GetChannel(projectId, channelId) {
    const response = await apiInterceptor(
        `${process.env.REACT_APP_MYXP_API_V2}/manager/livestream/channels/${channelId}?projectId=${projectId}`,
        {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        }
    );
    return await response.json();
}
